import { createSlice } from "@reduxjs/toolkit";
import { faqNonprofitAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const faqNonprofitSlice = createSlice({
  name: "faqNonprofit",
  initialState: data,
  reducers: {
    faqNonprofitSlice(state) {
      state.isLoading = false;
    },
    faqNonprofitSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    faqNonprofitSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    faqNonprofitSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const faqNonprofitHandler = () => async (dispatch: any) => {
  try {
    dispatch(faqNonprofitAction.faqNonprofitSlice());
    const response: any = await faqNonprofitAPI();
    dispatch(faqNonprofitAction.faqNonprofitSliceSuccess(response));
  } catch (e: any) {
    dispatch(faqNonprofitAction.faqNonprofitSliceFailure(e?.response?.data?.message));
    dispatch(faqNonprofitAction.faqNonprofitSliceReset());
  }
};
export default faqNonprofitSlice.reducer;
export const faqNonprofitAction = faqNonprofitSlice.actions;
